function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_237_488)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 10.2422,
  width: 103,
  height: 55.9202,
  rx: 27.9601,
  fill: "#BCCE76"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 53.3101,
  cy: 38.3444,
  rx: 7.1246,
  ry: 7.13171,
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 71.6305,
  cy: 38.3437,
  rx: 7.1246,
  ry: 7.13171,
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 89.9508,
  cy: 38.3437,
  rx: 7.1246,
  ry: 7.13171,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.615 83.2003L109.089 61.5504H85.9336L110.615 83.2003Z",
  fill: "#BCCE76"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_237_488",
  x: 0,
  y: 0.242188,
  width: 143,
  height: 112.958,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 10
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_237_488"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_237_488",
  result: "shape"
})));

var SvgContactUs = function SvgContactUs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 114,
    viewBox: "0 0 143 114",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactUs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contactUs.fa68aafa.svg";
export { ForwardRef as ReactComponent };